/* Be Inglewood v2 — header, reveal, carousel, rail drag, announcement rotation */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!reduce && 'IntersectionObserver' in window) document.documentElement.classList.add('be-js');

  function initHeader(root) {
    var header = root.querySelector('[data-be-header]');
    if (!header) return;
    if (header.classList.contains('be-header--overlay')) {
      var onScroll = function () {
        header.classList.toggle('is-solid', window.scrollY > window.innerHeight * 0.6);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
    var btn = header.querySelector('[data-be-menu]');
    var drawer = header.querySelector('[data-be-drawer]');
    if (btn && drawer) {
      btn.addEventListener('click', function () {
        var open = drawer.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        btn.textContent = open ? btn.getAttribute('data-close') : btn.getAttribute('data-open');
      });
    }
    var ann = header.querySelector('[data-be-announce]');
    if (ann) {
      var msgs = ann.querySelectorAll('.be-announce__msg');
      if (msgs.length > 1 && !reduce) {
        var i = 0;
        setInterval(function () {
          msgs[i].classList.remove('is-active');
          i = (i + 1) % msgs.length;
          msgs[i].classList.add('is-active');
        }, 3600);
      }
    }
  }

  function initReveal(root) {
    var els = root.querySelectorAll('.be-reveal:not(.is-in)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || reduce) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -10% 0px' });
    els.forEach(function (el) { io.observe(el); });
    setTimeout(function () { els.forEach(function (el) { el.classList.add('is-in'); io.unobserve(el); }); }, 6000);
  }

  function initCarousels(root) {
    root.querySelectorAll('.be-carousel:not([data-ready])').forEach(function (c) {
      c.setAttribute('data-ready', '1');
      var slides = c.querySelectorAll('.be-carousel__slide');
      if (!slides.length) return;
      var cap = c.querySelector('.be-carousel__cap');
      var dots = c.querySelector('.be-carousel__dots');
      var interval = parseInt(c.getAttribute('data-interval') || '4200', 10);
      var idx = 0, timer = null, paused = false;
      var dotEls = [];
      if (dots) {
        slides.forEach(function (_, k) {
          var d = document.createElement('button');
          d.type = 'button';
          d.className = 'be-carousel__dot';
          d.setAttribute('aria-label', 'Slide ' + (k + 1));
          d.addEventListener('click', function () { go(k); });
          dots.appendChild(d);
          dotEls.push(d);
        });
      }
      function go(n) {
        slides[idx].classList.remove('is-active');
        if (dotEls[idx]) dotEls[idx].classList.remove('is-active');
        idx = (n + slides.length) % slides.length;
        slides[idx].classList.add('is-active');
        if (dotEls[idx]) dotEls[idx].classList.add('is-active');
        if (cap) cap.textContent = slides[idx].getAttribute('data-cap') || '';
      }
      function start() {
        if (reduce || slides.length < 2) return;
        stop();
        timer = setInterval(function () { if (!paused) go(idx + 1); }, interval);
      }
      function stop() { if (timer) clearInterval(timer); timer = null; }
      var prev = c.querySelector('[data-be-prev]');
      var next = c.querySelector('[data-be-next]');
      if (prev) prev.addEventListener('click', function () { go(idx - 1); start(); });
      if (next) next.addEventListener('click', function () { go(idx + 1); start(); });
      c.addEventListener('mouseenter', function () { paused = true; });
      c.addEventListener('mouseleave', function () { paused = false; });
      go(0);
      start();
    });
  }

  function initRails(root) {
    root.querySelectorAll('.be-rail--drag:not([data-ready])').forEach(function (el) {
      el.setAttribute('data-ready', '1');
      var down = false, sx = 0, sl = 0, moved = false;
      el.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse') return;
        down = true; moved = false; sx = e.pageX; sl = el.scrollLeft;
      });
      el.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.pageX - sx;
        if (Math.abs(dx) > 4) { moved = true; el.classList.add('is-dragging'); }
        el.scrollLeft = sl - dx;
      });
      var up = function () { down = false; el.classList.remove('is-dragging'); };
      window.addEventListener('pointerup', up);
      el.addEventListener('click', function (e) { if (moved) { e.preventDefault(); moved = false; } }, true);
    });
  }

  function init(root) {
    root = root || document;
    initHeader(root);
    initReveal(root);
    initCarousels(root);
    initRails(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  // Theme editor: re-init when a section is (re)loaded
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

/* Be Inglewood v2 — product form: variant picking, availability, AJAX add to bag */
(function () {
  'use strict';
  function money(cents, fmt) {
    var v = (cents / 100).toFixed(2);
    return fmt ? fmt.replace(/\{\{\s*amount\s*\}\}/, v.replace(/\B(?=(\d{3})+(?!\d))/g, ',')).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100)) : '$' + v;
  }
  function initProduct(root) {
    root.querySelectorAll('[data-be-product]:not([data-ready])').forEach(function (el) {
      el.setAttribute('data-ready', '1');
      var variants = JSON.parse(el.querySelector('[data-be-variants]').textContent);
      var fmt = el.getAttribute('data-money-format') || '';
      var idInput = el.querySelector('input[name="id"]');
      var price = el.querySelector('[data-be-price]');
      var compare = el.querySelector('[data-be-compare]');
      var btn = el.querySelector('[data-be-atc]');
      var btnText = btn ? btn.getAttribute('data-label') : '';
      var soldText = btn ? btn.getAttribute('data-sold') : 'Sold out';
      var count = document.querySelector('[data-be-cart-count]');
      function selected() {
        var opts = [];
        el.querySelectorAll('[data-be-option]').forEach(function (g) {
          var c = g.querySelector('input:checked'); opts.push(c ? c.value : null);
        });
        return variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); }) || null;
      }
      function paintAvailability() {
        el.querySelectorAll('[data-be-option]').forEach(function (g, gi) {
          g.querySelectorAll('.be-opt').forEach(function (label) {
            var val = label.querySelector('input').value;
            var others = [];
            el.querySelectorAll('[data-be-option]').forEach(function (g2, i2) { if (i2 !== gi) { var c = g2.querySelector('input:checked'); others[i2] = c ? c.value : null; } });
            var ok = variants.some(function (v) { return v.available && v.options[gi] === val && v.options.every(function (o, i) { return i === gi || others[i] === null || others[i] === undefined || o === others[i]; }); });
            label.classList.toggle('be-opt--off', !ok);
          });
        });
      }
      function update() {
        var v = selected();
        paintAvailability();
        if (!v) { if (btn) { btn.disabled = true; btn.textContent = 'Unavailable'; } return; }
        idInput.value = v.id;
        if (price) price.textContent = money(v.price, fmt);
        if (compare) { if (v.compare_at_price && v.compare_at_price > v.price) { compare.textContent = money(v.compare_at_price, fmt); compare.hidden = false; } else compare.hidden = true; }
        if (btn) { btn.disabled = !v.available; btn.classList.remove('is-added'); btn.textContent = v.available ? btnText.replace('[price]', money(v.price, fmt)) : soldText; }
        try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u); } catch (e) {}
      }
      el.querySelectorAll('[data-be-option] input').forEach(function (i) { i.addEventListener('change', update); });
      var form = el.querySelector('form[action*="/cart/add"]');
      if (form && btn) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          btn.disabled = true; btn.textContent = 'Adding…';
          fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: parseInt(idInput.value, 10), quantity: 1 }] }) })
            .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
            .then(function () { return fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart.js').then(function (r) { return r.json(); }); })
            .then(function (cart) { if (count) count.textContent = cart.item_count; btn.disabled = false; btn.classList.add('is-added'); btn.textContent = btn.getAttribute('data-added'); setTimeout(update, 1800); })
            .catch(function () { form.removeEventListener('submit', arguments.callee); btn.disabled = false; form.submit(); });
        });
      }
      update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initProduct(document); }); else initProduct(document);
  document.addEventListener('shopify:section:load', function (e) { initProduct(e.target); });
})();
